import { TouchableOpacity, Text, ActivityIndicator, View } from "react-native";

interface ButtonProps {
  title: string;
  onPress: () => void;
  loading?: boolean;
  variant?: "primary" | "secondary" | "danger";
  disabled?: boolean;
}

export function Button({ title, onPress, loading, variant = "primary", disabled }: ButtonProps) {
  const bgColor = variant === "primary" ? "#1B2A4A" : variant === "danger" ? "#dc2626" : "#6b7280";
  const opacity = disabled || loading ? 0.6 : 1;

  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={disabled || loading}
      style={{
        backgroundColor: bgColor,
        paddingVertical: 14,
        paddingHorizontal: 24,
        borderRadius: 10,
        alignItems: "center",
        opacity,
        flexDirection: "row",
        justifyContent: "center",
        gap: 8,
      }}
    >
      {loading && <ActivityIndicator color="#fff" size="small" />}
      <Text style={{ color: "#fff", fontSize: 16, fontWeight: "600" }}>{title}</Text>
    </TouchableOpacity>
  );
}
